/* Shared PDP review presentation. Brand bundles retain ownership of purchasing UI. */
(() => {
  const main = document.getElementById('MainContent');
  if (!main || window.hopReviewsMounted) return;
  window.hopReviewsMounted = true;
  let summary, section;
  function refresh() {
    summary?.remove();
    section?.remove();
    main.querySelectorAll('[data-hop-nav]').forEach(el => el.remove());
    summary = document.getElementById('hop-rating-links-template')?.content.firstElementChild?.cloneNode(true);
    section = document.getElementById('hop-review-section-template')?.content.firstElementChild?.cloneNode(true);
    sync();
  }
  const adapters = [
    ['#napoleon-shopify-root', '.price-block', '#hx27-purchase,.pdp-grid,.product-layout,.pdp-top'],
    ['#outdoor-plus-root', '#configure .price', '#configure'],
    ['#afd-root', '.afd-price', '#configure'],
    ['#outdoor-greatroom-root', '.price-line,.price', '#configure,.product-section'],
    ['.fm-page[data-brand="Broil King"][data-qs690-mockup]', '.price-finance', '#upper'],
    ['.fm-page', '.fm-buy .fm-price,.fm-price', '.fm-hero,.pizza-review-page .fm-pdp-hero'],
    ['bromic-product', '.bromic-price', '.bromic-buy'],
    ['[data-standard-accessory]', '.fm-price', '.fm-hero,.pizza-review-page .fm-pdp-hero'],
    ['.product-info', ':scope > p', '.product-form']
  ];
  const legacy = '#customer-reviews,.customer-reviews,.fm-rating,.product-rating,#napoleon-shopify-root .rating,.fm-reviews,.fm-section#reviews,[data-review-widget-slot="product"],#outdoor-greatroom-root .review-stars';
  let queued = false;
  const observer = new MutationObserver(() => {
    if (!queued) { queued = true; requestAnimationFrame(sync); }
  });
  function sync() {
    queued = false;
    observer.disconnect();
    // Only retire legacy PDP customer-review elements; never touch project review dialogs.
    main.querySelectorAll(legacy).forEach(el => { el.hidden = true; el.setAttribute('data-hop-retired', ''); });
    main.querySelectorAll('a[href="#customer-reviews"],a[href="#reviews"]').forEach(el => { el.hidden = true; });
    if (summary && section) {
      let root, price, hero;
      for (const [rootSelector, priceSelector, heroSelector] of adapters) {
        const candidate = main.querySelector(rootSelector);
        const found = candidate?.querySelector(priceSelector);
        if (found && !found.closest('[hidden]')) { root = candidate; price = found; hero = candidate.querySelector(heroSelector) || main.querySelector(heroSelector); break; }
      }
      if (price) {
        const purchaseExtras = price.nextElementSibling?.matches('[data-hop-native-host="price"]') ? price.nextElementSibling : price;
        if (purchaseExtras.nextElementSibling !== summary) purchaseExtras.after(summary);
        const nav = root.matches('[data-qs690-mockup]') ? root.querySelector('.sectionnav') : main.querySelector('.hx27-nav,[data-top-pdp-nav],[data-fire-nav]');
        const anchor = (root.hasAttribute('data-paid-pdp-pilot') && root.querySelector('.fm-accordion')?.closest('section')) || nav || hero || root;
        if (anchor && anchor.nextElementSibling !== section) anchor.after(section);
        if (nav && !nav.querySelector('[data-hop-nav]')) {
          const a = document.createElement('a'); a.href = '#hop-owner-insights'; a.textContent = 'Ratings & Owner Insights'; a.dataset.hopNav = ''; nav.append(a);
        }
      }
    }
    observer.observe(main, {childList: true, subtree: true});
  }
  document.addEventListener('click', event => {
    const a = event.target.closest('a[href="#hop-owner-insights"]');
    const targetSection = main.querySelector('#hop-owner-insights');
    if (!a || !targetSection) return;
    event.preventDefault(); event.stopImmediatePropagation();
    const header = document.querySelector('.ho-header');
    const headerParts = header ? [header, ...header.querySelectorAll('nav')] : [];
    const offset = Math.max(0, ...headerParts.map(el => el.getBoundingClientRect().bottom)) + 16;
    const heading = targetSection.querySelector('.hop-review-heading');
    history.replaceState(history.state, '', '#hop-owner-insights');
    window.scrollTo({top: scrollY + heading.getBoundingClientRect().top - offset, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    heading.tabIndex = -1; heading.focus({preventScroll: true});
  }, true);
  refresh();
  document.addEventListener('hop:reviews-refresh', refresh);
  document.addEventListener('shopify:section:load', refresh);
})();
